import React, { useState } from "react";
import { Input, TextArea } from "../../../../components/Form";
import { optimizeFunction } from "../../../../utils/regex";
import { toastMessage } from "../../../../utils/toastMessage";
import ModalBox from "../../../../components/modal/ModalBox";
import { editContentApi } from "../../../../services/cms";
import useButtonLoader from "../../../../hooks/UseButtonLoader";

const EditNotice = ({
  setEditModal,
  editModal,
  selectedNotice,
  setSelectedNotice,
  setContentData,
  contentData,
  type,
}) => {
  const [buttonRef, buttonLoader] = useButtonLoader("Save");
  const [error, setError] = useState("");

  const modalClose = () => {
    setError("");
    setEditModal(false);
  };

  const validation = () => {
    if (!selectedNotice?.title) {
      setError("Title is mandatory");
      return false;
    }
    return true;
  };

  const editNoticeHandler = async () => {
    if (validation()) {
      try {
        buttonLoader(true);
        const formData = new FormData();
        formData.append("title", selectedNotice?.title);
        formData.append("subTitle", selectedNotice?.subTitle || "");
        formData.append("contentType", type);
        formData.append("noticeId", selectedNotice?.id || selectedNotice?._id);
        const { data } = await editContentApi(formData);
        if (data.code === 200) {
          toastMessage(data.message, "success", "editNotice");
          const targetId = selectedNotice?.id || selectedNotice?._id;
          setContentData(
            contentData.map((item) => {
              const itemId = item?.id || item?._id;
              if (itemId === targetId) {
                return selectedNotice;
              } else {
                return item;
              }
            })
          );

          modalClose();
        } else {
          toastMessage(data.message, "error", "editNotice");
        }
      } catch (error) {
        console.log("error", error);
      } finally {
        buttonLoader(false);
      }
    }
  };

  return (
    <ModalBox
      status={editModal}
      onClose={modalClose}
      title={"Edit Notice"}
      closeIcon
      size={"sm"}
      custom
      customizedFooter={
        <button
          className="btn_size"
          ref={buttonRef}
          onClick={editNoticeHandler}
        >
          Save
        </button>
      }
    >
      <div>
        <div className="form-group mb-2">
          <Input
            type="text"
            name="subTitle"
            value={selectedNotice?.subTitle || ""}
            onChange={(e) => {
              setSelectedNotice({
                ...selectedNotice,
                subTitle: e.target.value,
              });
            }}
            placeholder="Enter Sub Title..."
            className={`form-control`}
            label={"Sub Title"}
          />
        </div>
        <div className="form-group mb-2">
          <TextArea
            name="title"
            value={selectedNotice?.title || ""}
            required
            onChange={(e) => {
              setSelectedNotice({
                ...selectedNotice,
                title: e.target.value,
              });
            }}
            placeholder="Enter Title / Notice..."
            className={`form-control`}
            label={"Title"}
            error={!selectedNotice?.title && error}
          />
        </div>
      </div>
    </ModalBox>
  );
};

export default EditNotice;
